export default {
      id: "product_6_month-usage",
      viewBox: "0 0 45 45",
      url: __webpack_public_path__ + "img/icons.svg#product_6_month",
      toString: function () {
        return this.url;
      }
    }